<template>
  <div>
    <!--  header-->
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="database" />
            <span>{{ $t("message.DataSetTagManagement.title1") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="tag" />
            <span>{{ $t("message.DataSetTagManagement.title2") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title" style="margin-bottom: 20px">
      {{ $t("message.DataSetTagManagement.title2") }}
    </div>

    <!-- 按钮管理 search card   -->
    <div class="search">
      <a-card>
        <a-row :gutter="32">
          <a-col class="gutter-row" :span="7">
            <a-input :size="$globalSize" type="text" ref="tagIdInputValue"
              :placeholder="$t('message.addUserGroup.EnterTagID')" allowClear>
              <div slot="addonBefore">
                {{ $t("message.addUserGroup.TagID") }}：
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="7">
            <a-input :size="$globalSize" type="text" ref="tagCNSearchInput"
              :placeholder="$t('message.addUserGroup.EnterChineseTagName')" allowClear>
              <div slot="addonBefore">
                {{ $t("message.addUserGroup.ChineseTagName") }}：
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="10">
            <a-button :size="$globalSize" class="my-btn" style="width: 80px;float: right;" type="primary" @click="tagSearch">{{
              $t("message.commonUsage.search") }}</a-button>
          </a-col>
        </a-row>
      </a-card>
    </div>

    <!-- <a-spin :spinning="spinning" style="margin-top: 30px"> -->
    <div class="content">
      <a-card>
        <div class="left" style="
            display: inline-block;
            width: 23%;
            vertical-align: top;
            overflow-x: auto;
          ">
          <p style="margin-top: 30px; font-weight: bold; color: #000">
            {{ $t("message.addUserGroup.TagDisplay") }}
          </p>
          <a-spin :spinning="spinningTreeMenu" style="min-height: 100px">
            <a-tree v-if="treeData.length" :tree-data="treeData" :defaultSelectedKeys="defaultSelectedKeys"
              :defaultExpandedKeys="defaultExpandedKeys" show-line @select="onSelect">
            </a-tree>
          </a-spin>
        </div>
        <div class="right" style="display: inline-block; width: 77%; vertical-align: top">
          <a-table v-show="tagAuthShowWhich === '标签列表'" :columns="columns" row-key="id" :style="{
            marginTop: selectedTagIdList.length > 0 ? '95px' : '20px',
          }" :pagination="false" :data-source="tag_level_data" :loading="loading" :scroll="{ x: 1500 }">

            <template slot="tag_value" slot-scope="text">

              <a-tooltip placement="bottom">
                <template slot="title">
                  <div v-if="text.toString().length >= 18">
                    {{ text.toString() }}
                  </div>
                </template>
                <div v-if="text.toString().length >= 18">
                  {{ text.toString().substr(0, 18) }}
                </div>
              </a-tooltip>
              <div v-if="text.toString().length < 18">{{ text }}</div>
            </template>

            <template slot="tag_value" slot-scope="text, record">
              <span>{{ showValue(record.tag_value) }}</span>
            </template>

            <template slot="create_time" slot-scope="text, record">
              <span>{{ convertToDefaultTimezone(showTime(record.create_time)) }}</span>
            </template>

            <template slot="update_time" slot-scope="text, record">
              <span>{{ convertToDefaultTimezone(showTime(record.update_time)) }}</span>
            </template>


            <template slot="use" slot-scope="text, record, index">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{
                    record.status == 0
                      ? $t("message.userGroupList.enable")
                      : $t("message.userGroupList.disable")
                  }}</span>
                </template>
                <a-switch checked-children="" un-checked-children="" default-checked v-model="record.status == 1"
                  @change="changEnable(record, index)" />
              </a-tooltip>
            </template>
          </a-table>
          <my-pagination v-show="tagAuthShowWhich === '标签列表'" ref="myPaginationRef" @change="searchData"
            :total="totalCount" :immediately="false" style="padding-top: 20px"></my-pagination>

        </div>
      </a-card>
    </div>
    <!-- </a-spin> -->
  </div>
</template>
<script>
import utils from "@/utils";
import tagAuthorityManagementService from "@/interface/pages/Authority/tagAuthorityManagement";
import tagManagementService from "@/interface/pages/Tag/tagManagement";
import ATextarea from "ant-design-vue/es/input/TextArea";
import MyPagination from "@/components/MyPagination";
export default {
  name: "TagMgt",
  components: { ATextarea, MyPagination },
  data() {
    return {
      treeData: [],
      selectedKey: "",
      defaultSelectedKeys: [],
      defaultExpandedKeys: [],
      spinningTreeMenu: false,
      //search
      tagCNSearchInput: "",
      tagIdInputValue: "",
      tagAuthShowWhich: "标签列表",
      spinningTag: false,

      tagAuthLogfields: [
        {
          dataIndex: "id",
          key: "id",
          title: "ID",
          align: "left",
        },
        {
          dataIndex: "submit_user_name",
          key: "submit_user_name",
          title: () => this.$t("message.DataSetTagManagement.recdTabTitle1"),
          align: "left",
        },
        {
          dataIndex: "create_time",
          key: "create_time",
          title: () => this.$t("message.DataSetTagManagement.recdTabTitle2"),
          align: "left",
        },
        {
          dataIndex: "op_type",
          key: "op_type",
          title: () => this.$t("message.DataSetTagManagement.recdTabTitle3"),
          align: "left",
        },
        {
          dataIndex: "op_descp",
          key: "op_descp",
          title: () => this.$t("message.DataSetTagManagement.recdTabTitle4"),
          align: "left",
        },
        {
          dataIndex: "op_remark",
          key: "audit_remark",
          title: () => this.$t("message.DataSetTagManagement.recdTabTitle5"),
          align: "left",
        },
      ],
      tagAuthLogs: [],
      selectedTagIdList: [],
      search: "",
      tree_select: [],
      tree_input: "",
      // search_tree_option_data: [],

      columns: [
        {
          title: "ID",
          dataIndex: "id",
          sorter: (a, b) => a.id > b.id, //排序
          // width: 200,
          fixed: "left",
        },
        {
          title: () => this.$t("message.DataSetTagManagement.tagTabTitle1"),
          dataIndex: "dim_code",
          align: "left",
          width: 200,
          fixed: "left",
        },
        // {
        //   title: "标签分类",
        //   align: "left",
        //   dataIndex: "tag_group_type",
        //   width: 240,
        //   scopedSlots: { customRender: "tag_group_type" },
        // },
        {
          title: () => this.$t("message.DataSetTagManagement.tagTabTitle2"),
          align: "left",
          dataIndex: "dim_name_cn",
        },
        // {
        //   title: "标签中文名",
        //   align: "left",
        //   dataIndex: "tag_description",
        // },
        // {
        //   title: "备注",
        //   align: "left",
        //   dataIndex: "tag_sample",
        //   scopedSlots: { customRender: "tag_sample" },
        // },
        {
          title: () => this.$t("message.DataSetTagManagement.tagTabTitle3"),
          align: "left",
          dataIndex: "create_time",
          sorter: (a, b) =>
            this.string2Date(a.create_time) - this.string2Date(b.create_time),
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: () => this.$t("message.DataSetTagManagement.tagTabTitle4"),
          align: "left",
          dataIndex: "update_time",
          // width: 180,
          sorter: (a, b) =>
            this.string2Date(a.update_time) - this.string2Date(b.update_time),
          scopedSlots: { customRender: "update_time" },
        },
        // {
        //   title: "数据更新时间",
        //   align: "left",
        //   width: 150,
        //   dataIndex: "data_update_time",
        //   sorter: (a, b) =>
        //           this.string2Date(a.data_update_time) - this.string2Date(b.data_update_time),
        //   scopedSlots: { customRender: "data_update_time" },
        // },
        // {
        //   title: () => this.$t("message.DataSetTagManagement.tagTabTitle5"),
        //   align: "left",
        //   dataIndex: "use_count",
        //   scopedSlots: { customRender: "use_count" },
        //   // width: 100
        // },
        {
          title: () => this.$t("message.DataSetTagManagement.tagTabTitle6"),
          align: "center",
          dataIndex: "use",
          fixed: "right",
          // width: 100,
          scopedSlots: { customRender: "use" }, //格式化，需要注意的是a-table中插槽的绑定
        },
      ],
      tagAuthLogs_currentPage: 1,
      tagAuthLogs_pageSize: 10,
      submit_user_name: "",
      category: [],
      tag_level_data: [],
      tag_level_data1: [],
      spinning: false,
      loading: false,
      resTotalCount: 0,
      totalCount: 0,
      getDataType: "byLevel",
    };
  },
  created() { },
  mounted() {
    this.getTagTreeMenu();
  },
  watch: {
    getDataType(val) {
      this.$refs.myPaginationRef.initCurrent();
    },
  },
  methods: {
    searchData() {
      if (this.getDataType == "byLevel") {
        this.getTagsByLevel(this.selectedKey);
      } else {
        this.tagSearch();
      }
    },
    cannotBeSpaces(rule, value, callback) {
      if (value.trim().length == 0) {
        callback("输入内容不能全为空格！");
      } else {
        callback();
      }
    },
    getTagTreeMenu() {
      try {
        this.spinningTreeMenu = true;
        tagManagementService
          .getFitlerMyTagTree(this, { params: {} })
          .then(
            function (response) {
              let res = response.data;
              if (res.code == "200") {
                this.spinningTreeMenu = false;
                if (res.data.length) {
                  res.data.forEach((item) => {
                    if (item.children) {
                      item.children.forEach((childItem) => {
                        if (childItem.children) {
                          childItem.children.forEach((leaf) => {
                            leaf.isLeaf = true;
                          });
                        }
                      });
                    }
                  });
                  this.treeData = res.data;

                  let defaultKey = this.treeData[0].children[0].children[0].key;
                  this.selectedKey = defaultKey;
                  this.defaultSelectedKeys.push(defaultKey);
                  this.defaultExpandedKeys.push(defaultKey);
                  this.getTagsByLevel(defaultKey);
                }
              } else {
                if (res.code !== '400') {
                  this.$message.error(res.message);
                }
              }
            }.bind(this)
          )
          .catch((response) => {
            console.log(response);
          });
      } catch (error) {
        console.log(error);
        this.spinningTreeMenu = false
      }
    },
    onSelect(selectedKeys, info) {
      // console.log(selectedKeys, info);
      //叶子节点才能点击
      let isLeaf = info.node.isLeaf;
      let selectedKey = selectedKeys[0];
      if (isLeaf) {
        this.selectedKey = selectedKey;
        this.getTagsByLevel(selectedKey);
      }
    },
    getTagsByNameList(body) {
      this.loading = true;
      // this.defaultSelectedKeys = []
      tagManagementService
        .getTagsByName(this, { params: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.tag_level_data = res.data;
              this.loading = false;
              this.totalCount = res.totalCount;
            } else {
              this.tag_level_data = [];
              this.totalCount = 0;
              this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTagsByLevel(selectedKey) {
      try {
        this.getDataType = "byLevel";
        this.loading = true;
        let body = { levelid: selectedKey, ...this.$refs.myPaginationRef.pagination };
        tagManagementService
          .getTagsByLevel(this, { params: body })
          .then(
            function (response) {
              let res = response.data;
              if (res.code == "200") {
                this.tag_level_data1 = res.data;
                this.tag_level_data = res.data;
                this.loading = false;
                this.totalCount = res.totalCount;
              } else {
                this.tag_level_data = [];
                this.totalCount = 0;
                this.$message.error(res.message);
              }
            }.bind(this)
          )
          .catch((response) => {
            console.log(response);
          });
      } catch (error) {
        console.log(error);
        this.loading = false
      }
    },
    onTreeChange() {
      this.$forceUpdate();
    },
    getSubmitRecordList() {
      this.spinning = true;
      var data = {
        submit_user_name: this.submit_user_name,
        category:
          typeof this.category != "undefined" && this.category.length > 0
            ? this.category
            : "",
        ...this.$refs.myPaginationResRef.pagination,
      };
      tagAuthorityManagementService
        .getSubmitRecordList(this, { params: data })
        .then(
          function (resp) {
            var res = resp.data;

            if (res.code == "200") {
              this.tagAuthLogs = res.data;
              this.resTotalCount = res.totalCount;
              setTimeout(() => {
                this.spinning = false;
              }, 700);
            } else {
              this.spinning = false;
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    changEnable(record, index) {
      var that = this;
      if (record.status == 1 ? true : false) {
        that.$confirm({
          title: this.$t("message.DataSetTagManagement.popupTitle4"),
          okText: this.$t("message.DataSetTagManagement.popupTitle6"),
          okType: "primary",
          cancelText: this.$t("message.commonUsage.cancel"),
          onOk() {
            return new Promise((resolve, reject) => {
              that.tag_level_data[index].status = 0;
              that.tag_level_data[index].use = false;
              that.updTag(record, 0, resolve);
            });
          },
          onCancel() {
            console.log("Cancel");
            //that.tag_level_data[index].status = 1;
          },
        });
      } else {
        that.$confirm({
          title: this.$t("message.DataSetTagManagement.popupTitle1"),
          okText: this.$t("message.DataSetTagManagement.popupTitle3"),
          okType: "primary",
          cancelText: this.$t("message.commonUsage.cancel"),
          onOk() {
            return new Promise((resolve, reject) => {

              that.tag_level_data[index].status = 1;
              that.tag_level_data[index].use = true;
              that.updTag(record, 1, resolve);
            })
          },
          onCancel() {
            console.log("Cancel");
            //that.tag_level_data[index].status = 0;
          },
        });
      }
    },
    // 禁用/启用按钮操作
    async updTag(record, status, resolve = () => { }) {
      this.spinning = true;
      var selectedTagIdList = [];
      let body = {
        tag_id: record.dim_code,
        status: status
      };
      const { data: res } = await tagManagementService.updTag(this, { data: body })
      if (res.code == "200") {
        var that = this;
        selectedTagIdList.push(parseInt(record.id));
        let params = {
          idList: selectedTagIdList,
          status: status,
        };
        let body2 = {
          audit_param: JSON.stringify(params),
        };

        that.$message.success(res.message, 3);
        that.getTagsByLevel(this.selectedKey);
        that.spinning = false;
        resolve()

      } else {
        this.$message.error(res.message, 3);
        this.spinning = false;
      }
    },
    tableSearchInput(value) {
      this.tree_input = value;
    },
    changeTableSearchFilter(value) {
      let selectArr = value;
      if (value.length > 0) {
        let arrList = [];
        selectArr.forEach((item) => {
          this.tag_level_data1.forEach((itemList) => {
            if (
              item.toString().toLowerCase() ==
              itemList.dim_code.toString().toLowerCase()
            ) {
              arrList.push(itemList);
            }
          });
        });
        this.tag_level_data = arrList;
      } else {
        this.tag_level_data = this.tag_level_data1;
      }
    },
    tableSearchFilter(tag_level) {
      if (this.tagIdInputValue == "") {
        return true;
      } else {
        return tag_level.dim_code
          .toString()
          .toLowerCase()
          .includes(this.tagIdInputValue.toLowerCase());
      }
    },
    tagNameSearchFilter(tag_level) {
      if (this.tagCNSearchInput == "") {
        return true;
      } else {
        return tag_level.dim_name_cn
          .toString()
          .toLowerCase()
          .includes(this.tagCNSearchInput.toLowerCase());
      }
    },
    string2Date(str) {
      return new Date(str);
    },
    showTime(value) {
      if (
        typeof value == "undefined" ||
        value == null ||
        value == "-" ||
        value == "" ||
        value.length < 1
      ) {
        return "-";
      }
      return utils.formatDate(new Date(value), "yyyy-MM-dd hh:mm:ss");
    },
    showValue(value) {
      if (
        typeof value == "undefined" ||
        value == null ||
        value == "-" ||
        value == "" ||
        value.length < 1
      ) {
        return "-";
      }
      return value;
    },

    changeTagAuthPage() {
      if (this.tagAuthShowWhich == "标签权限") {
      } else if (this.tagAuthShowWhich == "提交记录") {
        this.selectedTagIdList = [];
      }
    },
    tagSearch() {
      this.getDataType = "byName";

      let body = {
        code: this.$refs.tagIdInputValue.$data.stateValue,
        name: this.$refs.tagCNSearchInput.$data.stateValue,
        ...this.$refs.myPaginationRef.pagination,
      };
      this.getTagsByNameList(body);
    },
  },
};
</script>
<style scoped lang="less">
.right ::v-deep .ant-table-tbody tr {
  height: 90px !important;
}
</style>
